import { render } from "./Nav.vue?vue&type=template&id=4820191a&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=4820191a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4820191a"

export default script